
// For backwards compatibility during transition
export const getEmployeesData = () => [];
